import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi";
import { useNotification } from "~hooks/useNotification";
import type { DefaultOperationSuccessResponse } from "~types/response";

const useDeletePerson = () => {
  const { sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (personId: string) => {
      return await request(`${sport}/o/${organizationId}/persons/${personId}`, { method: "DELETE" });
    },
    onSuccess: (response: DefaultOperationSuccessResponse) => {
      if (response?.data[0]?.success) {
        notification.success({
          message: formatMessage({ id: "person.delete.success" }),
          placement: "bottomRight",
        });
        queryClient.invalidateQueries({ queryKey: ["persons"] });
      }
    },
  });
};

export default useDeletePerson;
